export const isLocal = process.env.NODE_ENV === "development";
export const isStaging = process.env.NODE_ENV === "staging";

export const isProd = process.env.NODE_ENV === "production";

export const BASE_PROD_URL = `https://www.nudiez.tv`;

export const BASE_LOCAL_URL = `http://localhost:3000`;

export const BASE_STAGING_URL = `http://emu.nudiez-staging.staging.c66.me`;

export const API_VERSION = "/api/v2/";

export const getBaseUrl = () => {
  if (isProd) {
    return BASE_PROD_URL;
  }
  if (isStaging) {
    return BASE_STAGING_URL;
  }
  return BASE_LOCAL_URL;
};

export const BASE_URL = getBaseUrl();

export const INFLUENCER_APPLICATIONS_URL = `${API_VERSION}influencer_applications`;

export const endpointBuilder = {};
